module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Payment and Confirmation","suvUpgrade":{"checkbox":{"label":"Allow SUV upgrade at no additional charge if a sedan is unavailable"}},"tos":{"checkbox":{"label":"I have read and agree to the above terms and conditions"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Request.vue
// module id = 171
// module chunks = 1